module.exports = MaterialUI.DialogTitle;